import { ApiData } from 'states/types'
import { NivosFolder } from 'types/nivos-folder'

const Types = {
  SET: '@@document/SET',
  ADD: '@@document/ADD',
  UPDATE: '@@document/UPDATE',
  LOADING: '@@document/LOADING',
  SETTERS: '@@document/SETTERS'
}

export type Payload = ApiData<NivosFolder>

export { Types }
